export default "__VITE_ASSET__DjHTcz4R__"